import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import styles from './SideMenuButton.module.scss';
import ICONS from '../../static/media/icons/icons-helper';
import { fadeInLeft } from '../../utils/animations-configs';

const SideMenuButton = ({ title, path, onClick }) => {
  return (
    <motion.li
      className={styles.buttonWrapper}
      variants={fadeInLeft}
      onClick={() => onClick(path)}
    >
      <div className={styles.verticalLine} />
      <span className={styles.buttonTitle}>{title}</span>
      <img
        className={styles.arrowIcon}
        src={ICONS.RIGHT_ARROW}
        alt="icon-img"
      />
    </motion.li>
  );
};

SideMenuButton.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SideMenuButton;
